const TRIM_COUNT = 5;
const THUMB_WIDTH = 14;
const START_TRANSITION = 2;
const THUMB_GAP = 3;

function getDirectionByAngle(angle: number) {
  if ((angle <= 45 && angle >= 0) || (angle <= 360 && angle >= 315) || (angle >= 135 && angle <= 225)) {
    return 'horizontal';
  } else {
    return 'vertical';
  }
}

function getSwipeDirection(xDist: number, yDist: number) {
  const r = Math.atan2(yDist, xDist);

  let swipeAngle = Math.round((r * 180) / Math.PI);
  if (swipeAngle < 0) {
    swipeAngle = 360 - Math.abs(swipeAngle);
  }

  return getDirectionByAngle(swipeAngle);
}

function isSmallThumb(active: number, dataLength: number, index: number) {
  if (active === 1) {
    if (index === 0 || index === TRIM_COUNT - 1) {
      return true;
    }
  }

  if (active >= START_TRANSITION) {
    if (active === dataLength - 1) {
      if (active - index === THUMB_GAP) {
        return true;
      }
    } else if (active === dataLength - 2) {
      if (active - index === THUMB_GAP) {
        return true;
      }
      if (index === dataLength - 1) {
        return true;
      }
    } else if (Math.abs(active - index) === START_TRANSITION) {
      return true;
    }
  }

  return active === 0 && index === TRIM_COUNT - 2;
}

function isSmallerThumb(active: number, dataLength: number, index: number) {
  if (active === 0 && index === TRIM_COUNT - 1) {
    return true;
  }
  return active === dataLength - 1 && index === dataLength - TRIM_COUNT;
}

export {
  TRIM_COUNT,
  isSmallThumb,
  isSmallerThumb,
  THUMB_WIDTH,
  START_TRANSITION,
  getSwipeDirection,
  getDirectionByAngle,
};
